module.exports = __webpack_public_path__ + "static/media/nvuv.d5657742.mp3";